// extracted by mini-css-extract-plugin
module.exports =  {"spinner":"yE6p71_ivnFHeMYFVaHA"};